<template>
    <div class="max-w-2xl mx-auto p-4">
        <h1 class="text-2xl font-semibold text-theme-base mb-2">
            Métodos de pago del checkout
        </h1>
        <p class="text-sm text-theme-muted mb-6">
            Métodos de pago disponibles para tus clientes en el catálogo
            público. No afecta los métodos de pago internos del portal, que se
            configuran en
            <router-link
                to="/app/settings/payment-methods"
                class="text-theme-primary underline"
            >
                Métodos de pago del portal </router-link
            >.
        </p>

        <div class="bg-theme-card rounded-xl p-6 flex flex-col gap-8">
            <section>
                <div class="flex flex-wrap gap-3">
                    <label
                        v-for="method in availablePaymentMethods"
                        :key="method.value"
                        class="flex items-center gap-2 cursor-pointer"
                    >
                        <custom-checkbox
                            :value="method.value"
                            :checked="
                                settings.paymentMethodsAvailable.includes(
                                    method.value
                                )
                            "
                            @change="togglePaymentMethod(method.value)"
                        />
                        <span class="text-sm text-theme-base">{{
                            method.label
                        }}</span>
                    </label>
                </div>
            </section>

            <div class="flex justify-end pt-2">
                <app-button :loading="isLoading" @click="save">
                    Actualizar
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { paymentMethodsCodes } from "@/common/fields/orders-payment-methods";
import {
    defaultOrdersSettings,
    mapOrdersSettingsFromApi,
    mapOrdersSettingsToApi
} from "@/common/fields/orders-settings";

export default {
    name: "CheckoutPaymentMethodsSettingsPage",
    layout: "app",
    data: () => ({
        isLoading: false,
        availablePaymentMethods: Object.entries(paymentMethodsCodes).map(
            ([value, label]) => ({ value, label })
        ),
        settings: defaultOrdersSettings()
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (
            !(await verifyPagePermission(
                "tenant:GetOrdersSettings",
                "/app/settings"
            ))
        )
            return;
        await this.loadSettings();
    },
    methods: {
        ...mapActions("tenants", [
            "getTenantOrdersSettings",
            "updateTenantOrdersSettings"
        ]),
        async loadSettings() {
            this.$loading.show();
            try {
                const data = await this.getTenantOrdersSettings();
                this.settings = mapOrdersSettingsFromApi(data);
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        togglePaymentMethod(method) {
            const current = [...this.settings.paymentMethodsAvailable];
            const idx = current.indexOf(method);
            if (idx === -1) {
                current.push(method);
            } else {
                current.splice(idx, 1);
            }
            this.settings.paymentMethodsAvailable = current;
        },
        async save() {
            this.$loading.show();
            this.isLoading = true;
            try {
                await this.updateTenantOrdersSettings(
                    mapOrdersSettingsToApi(this.settings)
                );
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        }
    }
};
</script>
